import React, { useState } from 'react';
import { addCategory } from '../../services/categoryService';
import { useNavigate } from 'react-router-dom';
import CategoryForm from './CategoryForm';
import { useGroupContext } from '../Groups/useGroupContext';

const AddCategory = () => {
  const navigate = useNavigate();
  const { getContextParams } = useGroupContext();
  const handleCreate = async (newCategory) => {
    const contextParams = getContextParams();
    try {
      
      await addCategory(newCategory, contextParams);
      //alert('Category created successfully');
      navigate('/categories');
    } catch (error) {
      console.error(error);
      alert('Error creating category');
    }
  };

  return (
    <CategoryForm isEdit = {false} onSubmit={handleCreate}/>
  );
};

export default AddCategory;
